import React, { memo, HTMLProps } from 'react'
import classNames from 'classnames'
import { Tooltip } from 'transfix-ui/components/Tooltip'
import uuid from 'uuid/v4'
import { InfoIcon } from 'transfix-icons'

export interface ICheckBoxProps extends HTMLProps<HTMLInputElement> {
  name?: string
  semiChecked?: boolean
  disabled?: boolean
  label?: string
  ariaLabel?: string
  dataTest?: string
  tooltip?: JSX.Element
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
  onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void
}

/** @deprecated */
export const Checkbox = memo<ICheckBoxProps>(
  ({
    checked,
    semiChecked,
    disabled,
    name = '',
    defaultChecked = undefined,
    value = '',
    id = uuid(),
    onChange,
    className = '',
    label,
    ariaLabel = '',
    dataTest = 'checkbox',
    tooltip,
    onKeyDown,
    onKeyPress,
  }) => {
    const inputClassName = classNames('deprecated-checkbox', {
      'semi-checked': semiChecked,
    })
    return (
      <span className={`flex items-center mr1 ${className}`}>
        <input
          type='checkbox'
          data-test={dataTest}
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
          onKeyPress={onKeyPress}
          onKeyDown={onKeyDown}
          disabled={disabled}
          id={id}
          defaultChecked={defaultChecked}
          className={inputClassName}
        />
        {label && (
          <label aria-label={ariaLabel} htmlFor={id}>
            {label}
            {tooltip && (
              <Tooltip
                position='top'
                trigger={
                  <span>
                    <InfoIcon size='medium' className='ml1 tracking-disabled' />
                  </span>
                }
                effect='solid'
                type='dark'>
                {tooltip}
              </Tooltip>
            )}
          </label>
        )}
      </span>
    )
  }
)
